import { matchPath } from 'react-router-dom'

export function getActive(path: string, pathname: string, exact: boolean): boolean {
  if (exact) {
    return path === pathname
  }

  return path ? !!matchPath({ path, end: false }, pathname) : false
}
